import React, { FC } from 'react';

import { NewSoeknadWeb } from '../../generated-types';
import UserMessageMedlaantakerActive from './userMessageMedlaantakerActive';

import UserMessageUnder18 from './userMessageUnder18';

interface Props {
    soeknad: NewSoeknadWeb;
}

const UserMessage: FC<Props> = ({ soeknad }) => {
    if (soeknad?.soeknadId && soeknad.status.includes('MEDLAANTAKER')) {
        return <UserMessageMedlaantakerActive soeknadId={soeknad.soeknadId} />;
    }
    if (soeknad.laantaker.alder < 18) {
        return <UserMessageUnder18 />;
    }
    return <></>;
};

export default UserMessage;
